module.exports = __webpack_public_path__ + "static/media/map-marker.3708b557.svg";